<!-- mainBrand -->
<div class="mainBrand">
    <!-- <h2 class="bTit">
        <span>Ceriome</span>
        세리옴
    </h2> -->
    <div class="br-logo">
        <h1 class="br-bg-logo"><a title="HOME" class="logo"><img src="./assets/img/Logo.svg" alt=""></a></h1>
    </div>
    
    <!-- <p class="mainBrandTxt">Ceriome은 ‘세라마이드(Ceramide)’와 ‘마이크로바이옴(Microbiome)’의 <i></i>합성어로, 건강하고 균형잡힌 피부환경을 만드는데 <i></i>도움을 주는 셀리뉴의 새로운 기초라인입니다. </p> -->
    <ul class="ProdList">
        <ng-container *ngFor="let item of products">
            <li [product]="item"></li>
        </ng-container>
    </ul>
</div>
<!-- //mainBrand -->